import type { LiveTimeslotType } from "./types";

interface CartItemInputType {
  quantity: number;
  vendorCategoryId: string;
}

export function calculateCartItems(
  liveTimeslot: LiveTimeslotType,
  defaultNumberOfPlayers?: number
): CartItemInputType[] {
  const pricingCategories = liveTimeslot.pricingCategories || [];
  const minPlayers = liveTimeslot.minPlayers ?? 0;
  const maxPlayers = Math.min(
    liveTimeslot.maxPlayers ?? 0,
    liveTimeslot.slotsLeft ?? 0
  );
  const slotsLeft = liveTimeslot.slotsLeft ?? 0;

  if (pricingCategories.length !== 1) {
    return [];
  }

  const vendorCategoryId = pricingCategories[0]?.vendorCategoryId;
  if (!vendorCategoryId) {
    return [];
  }

  let numberOfPlayers = Math.min(
    Math.max(Math.floor(slotsLeft / 2), minPlayers),
    Math.max(minPlayers, Math.min(maxPlayers, 4))
  );

  if (
    defaultNumberOfPlayers !== undefined &&
    defaultNumberOfPlayers >= minPlayers &&
    defaultNumberOfPlayers <= maxPlayers
  ) {
    numberOfPlayers = defaultNumberOfPlayers;
  }

  return [
    {
      quantity: numberOfPlayers,
      vendorCategoryId,
    },
  ];
}

export function canCreateCart(liveTimeslot: LiveTimeslotType): boolean {
  const maxPlayers = liveTimeslot.maxPlayers ?? 0;
  const slotsLeft = liveTimeslot.slotsLeft ?? 0;
  const available = liveTimeslot.available ?? false;

  return available && maxPlayers > 0 && slotsLeft > 0;
}
